export default __webpack_public_path__ + "static/media/911.e6122d3f.png";